import DataKeys from 'k8s/DataKeys'
import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import { keys } from 'ramda'
import { doAllKeysAndValuesMatch } from 'app/plugins/openstack/helpers'

export const flavorsSelector = createSharedSelector(
  getDataSelector<DataKeys.Flavors>(DataKeys.Flavors),
  getDataSelector<DataKeys.HostAggregates>(DataKeys.HostAggregates),
  (flavors, hostAggregates) => {
    return flavors.map((flavor) => {
      const isGpuFlavor = keys(flavor?.extra_specs).some(
        (key) =>
          key === 'pci_passthrough:alias' ||
          key.toString().includes('trait:') ||
          /^resources\d*:/.test(key.toString()),
      )
      const matchingHostAggregates = hostAggregates.filter((hostAggregate) => {
        return doAllKeysAndValuesMatch(hostAggregate?.metadata, flavor?.extra_specs)
      })

      return {
        ...flavor,
        visibility: flavor['os-flavor-access:is_public'] ? 'Public' : 'Private',
        gpuFlavor: isGpuFlavor,
        matchingHostAggregates,
      }
    })
  },
)

export const flavorsByIdSelector = createSharedSelector(flavorsSelector, (flavors) => {
  return flavors.reduce((accum, flavor) => {
    return {
      ...accum,
      [flavor.id]: flavor,
    }
  }, {})
})
